export default {
  header: 'My Page',
  changePassword: {
    header: 'Change Password',
    oldPassword: 'Original Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    changePassword: 'Change Password',
  },
  customerProfile: {
    header: 'Profile',
  },

  profile: {
    language: 'System Language',
    header: 'My Profile',
    personalInformation: 'Personal Information',
    chineseName: 'Chinese Name',
    englishName: 'English Name',
    agentCode: 'FC Code',
    contactInformation: 'Contact Information',
    licenseInformation: {
      header: 'License Information',
      oci: {
        header: 'OCI Related',
        ociLicensePrinciples: 'License Principles',
        ociLicenseGeneral: 'License General',
        ociLicenseLongTerm: 'License Long Term',
        ociLicenseLinkedLongTerm: 'License Linked Long Term',
        ociLicenseTravel: 'License MPF',
      },
      sfc: {
        header: 'SFC Related',
        sfcLicenseType1: 'Type 1',
        sfcLicenseType2: 'Type 2',
        sfcLicenseType3: 'Type 3',
        sfcLicenseType4: 'Type 4',
        sfcLicenseType5: 'Type 5',
        sfcLicenseType6: 'Type 6',
        sfcLicenseType7: 'Type 7',
        sfcLicenseType8: 'Type 8',
        sfcLicenseType9: 'Type 9',
        sfcLicenseType10: 'Type 10'
      },
    },
    cpd:{
        header: 'CPD Information',
        pts: 'Points',
        corePts: 'Core Points',
        nonCorePts : 'Non-Core Points',
        totalPts : 'Total Points',
        training: {
          provider: 'Provider',
          name: 'Training Name',
          time: 'Training Time',
          date: 'Training Date',
          type: 'Training Type',
        }
      }
  }
}



// WEBPACK FOOTER //
// ./src/My/langs/en_us/index.js